import React, { Component } from "react";
import "../dashboard/css/nav.css";
import "../dashboard/css/font-awesome.css";
import "../dashboard/css/fontastic.css";
import axios from "axios";
import Navigation from "./Navigation";
import Page from "./overview/Page";
import { withRouter } from "react-router-dom";
import https from "https";
const instance = axios.create({
  httpsAgent: new https.Agent({
    rejectUnauthorized: false
  })
});
export class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datos: [
        {
          nombresitio: [
            {
              _id: "5de77233e4c95d1640c0c077",
              nombre: "Actualizando"
            }
          ]
        },
        {
          lecturas: [
            {
              _id: "0",
              caudal_1: null,
              volumen_1: null,
              caudal_2: null,
              volumen_2: null,
              fechalec: "null",
              fechalectura: "2019-01-01T00:00:00.000Z",
              estatus: "No hay Datos",
              senal: null,
              temp_equipo: null,
              bateria: null
            }
          ]
        },
        {
          ultimalectura: [
            {
              _id: "0",
              caudal_1: null,
              volumen_1: null,
              caudal_2: null,
              volumen_2: null,
              fechalec: "null",
              fechalectura: "2019-01-01T00:00:00.000Z",
              estatus: "No hay Datos",
              senal: null,
              temp_equipo: null,
              bateria: null
            }
          ]
        },
        {
          volmes1: 0
        },
        {
          volmes2: 0
        },
        {
          volsem1: 0
        },
        {
          volsem2: 0
        },
        {
          voldia1: 0
        },
        {
          voldia2: 0
        },
        {
          estatus: "Actualizando"
        }
      ],
      contador: 1,
      sitio: ""
    };
  }

  async componentDidMount() {
    var query = window.location.href;
    var sit = query.split("/");
    const res = await instance.get(
      "https://api.instrutronica-iot.com/api/pruebas/overview2/" + sit[5]
    );
    this.setState({ datos: res.data }, () => {
      this.setState({ contador: this.state.contador++ }, () => {
        this.render();
      });
    });
    this.setState({ sitio: sit[5] });

    this.interval = setInterval(async () => {
      var d = new Date();
      var n = d.getMinutes();
      var seg = d.getSeconds();
      if (localStorage.getItem("pruebas_app") == null) {
        this.props.history.push("/");
      }
      //console.log(seg);
      if (n === 1 || n === 11 || n === 21 || n === 31 || n === 41 || n === 51) {
        if (seg === 0) {
          const res = await instance.get(
            "https://api.instrutronica-iot.com/api/pruebas/overview2/" + sit[5]
          );
          this.setState({ datos: res.data }, () => {
            this.setState({ contador: this.state.contador++ }, () => {
              this.render();
            });
          });
        }
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    //console.log(this.state.datos);
    return (
      <div>
        <Navigation />
        <Page lecturas={this.state.datos} contador={this.state.contador} />
      </div>
    );
  }
}
/*nombre={this.state.datos[0].nombresitio[0].nombre} mes={this.state.datos[2].mes} semana={this.state.datos[3].semana}  lecturas={this.state.datos[1].lecturas} ultimalectura={this.state.ultimalectura} */
export default withRouter(Dashboard);
